import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frequency'
})
export class FrequencyPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    value = value || '';
    if (value % 1 === 0) {
      // The frequency is an integer
      return value.toString() + '.0';
    } else {
      return value + '';
    }
  }
}
